import { DateTime } from "luxon"

import { apiClient, assertOk } from "@/api/generated/client.ts"

import type { Farm } from "../types/logisticsTypes.ts"

export const getFarmTripData = async (): Promise<Farm[]> => {
  const start = DateTime.now().setZone("America/Chicago").startOf("day").minus({ days: 7 }).toISO()

  const startMonth = DateTime.now().setZone("America/Chicago").startOf("month").toISO()

  const end = DateTime.now()
    .setZone("America/Chicago")
    .startOf("day")
    .plus({ days: 1 })
    .minus({ seconds: 1 })
    .toISO()
  const responses = await Promise.all([
    apiClient.GET("/api/Logistics/farms", {
      params: {
        query: {
          IncludeTrips: true,
          TripAggregation: "Daily",
          Start: start ?? "",
          End: end ?? "",
        },
      },
    }),
    apiClient.GET("/api/Logistics/farms", {
      params: {
        query: {
          IncludeTrips: true,
          TripAggregation: "Monthly",
          Start: startMonth ?? "",
          End: end ?? "",
        },
      },
    }),
  ])
  const [days, months] = [
    assertOk<Farm[]>(responses[0].response, responses[0].error, responses[0].data),
    assertOk<Farm[]>(responses[1].response, responses[1].error, responses[1].data),
  ]

  for (let i = 0; i < days.length; i++) {
    const cat = days[i]
    const month = months.find((m) => m.id == cat.id)
    if (cat.trips && month?.trips) {
      cat.trips.push({ ...month.trips[0], start: "MTD" })
    }
  }

  return days
}
